import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { DataserviceService } from 'src/app/dataservice.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-dish-install',
  templateUrl: './dish-install.component.html',
  styleUrl: './dish-install.component.css'
})
export class DishInstallComponent implements OnInit {
  @Input() fullData: any;
  @Output() installData = new EventEmitter<any>();

  availableDates: any; 
  selectedSlot: any = null;
  installDate: any = null;
  showAllDates = false;

  loadingId: any;
  submitting: boolean = false;

  constructor(
    private data: DataserviceService,
    private message: NzMessageService
  ) { }

  ngOnInit() {
    console.log(this.fullData)
    this.getData();
  }

  getData() {
    this.message.remove(this.loadingId)
    this.loadingId = this.message.loading('Getting install dates...', { nzDuration: 0 }).messageId;
    this.data.postDataNoBodyDotBody( {
      conversationId: this.fullData.conversationId,
      promoId: this.fullData.qual.promoId
    }, 'dish/getInstallDates').subscribe(
      (r: any) => {
        if(r.data?.InstallationDatesResponse?.AvailableDates) {
          const grouped: { [key: string]: any[] } = {};
          r.data?.InstallationDatesResponse?.AvailableDates.forEach((item: any) => {
            const { Day, Month, Year } = item.InstallDate.Date;
            const dateKey = `${Day}-${Month}-${Year}`;
            const slot = {
              slotCode: item.InstallDate.SlotCode,
              windowStartTime: item.WindowStartTime,
              windowEndTime: item.WindowEndTime,
              date: dateKey
            };
            if (!grouped[dateKey]) grouped[dateKey] = [];
            grouped[dateKey].push(slot);
          });
  
          this.availableDates = Object.entries(grouped).map(([date, slots]) => ({ date, slots }));
  
          if(this.fullData?.install) {
            const install = this.fullData.install;
  
            this.selectedSlot = this.availableDates
              .flatMap((d: any) => d.slots)
              .find((s: any) =>
                s.slotCode === install.slotCode &&
                s.date === install.date &&
                s.windowStartTime === install.windowStartTime &&
                s.windowEndTime === install.windowEndTime
              );

              if (this.selectedSlot) {
                this.installDate = this.selectedSlot;
              }

          }
        }else {
          alert('Unable to get install dates')
        }

        this.message.remove(this.loadingId)
      },
      (e) => {
        console.error('Error loading install dates:', e);
        alert('Failed to load install dates. Please try again.');
        this.message.remove(this.loadingId)
      }
    );
  }

  formatDate(date: string): string {
    const [day, month, year] = date.split('-').map(Number);
    const d = new Date(year, month - 1, day);

    const options: Intl.DateTimeFormatOptions = { weekday: 'short', month: 'short', day: 'numeric' };
    return d.toLocaleDateString(undefined, options);
  }

  selectDate(slot: any, dateStr: string) {
    this.installDate = {
      ...slot,
      date: dateStr
    };
  }

  submitTime() {
    this.submitting = true;
    this.message.remove(this.loadingId)
    this.loadingId = this.message.loading('Submitting install dates...', { nzDuration: 0 }).messageId;
    this.data.postDataNoBodyDotBody({
      woId: this.fullData.woId,
      id: this.fullData.customerId,
      generic: {
        installInfo: this.selectedSlot
      }
    },'work-order/update-generic').subscribe(
      (r: any) => {
        this.message.remove(this.loadingId)
        this.installData.emit(this.selectedSlot);
        this.submitting = false;
      },
      (e) => {
        console.error('Install submit error:', e);
        this.submitting = false;
        this.message.remove(this.loadingId)
        alert('Failed to submit install time.');
      }
    );
  }

  toggleShowAll() {
    this.showAllDates = !this.showAllDates;
  }

  formatTime(time: string): string {
    let [hour, minute] = time.split(':').map(Number);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    hour = hour % 12 || 12;
    return `${hour}:${minute.toString().padStart(2, '0')} ${ampm}`;
  }

  onRadioChange(ev: any) {
    if(ev?.detail?.value?.slotCode) {
      this.selectedSlot = ev?.detail?.value
      this.installDate = ev?.detail?.value
    }
  }

  //Stupid but to keep the label on the right of the checkbox and to make the label clickable gotta do this
  labelClick(t: any) {
    this.selectedSlot = t
    this.installDate = t
  }

  isDateActive(date: { date: string }): boolean {
    if (!date) {
      return false;
    }
    if (this.selectedSlot?.date === date.date) {
      return true;
    }
    return this.installDate?.date === date.date;
  }

}
